<template>
  <div
    class="riskType-wrap"
    @mouseenter="handleInterval('enter')"
    @mouseleave="handleInterval('leave')"
  >
    <Card-border></Card-border>
    <div class="riskType-top">
      <div class="riskType-top-left">
        <div class="riskType-title">风险类型</div>
        <div class="riskType-select">
          <a-select
            v-if="activeVal === 'scan'"
            ref="select"
            :value="typeActiveVal"
            :options="selectOption"
            @change="handleSelectChange"
          >
          </a-select>
        </div>
      </div>
      <div class="riskType-top-right">
        <div class="riskType-radiobtn">
          <RadioBtn
            :config="DEFAULTCONFIG"
            :activeVal="activeVal"
            :autoChange="true"
            @onChange="radioChange"
            :counter="props.counter"
            ref="radioBtnRef"
          />
        </div>
      </div>
    </div>
    <div class="riskType-content">
      <PieChart
        :pieData="chartData"
        :domId="`riskType`"
        :chartConfig="echartsConfig"
        :click="handleLinkTo"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import CardBorder from "@/components/common/card-border.vue";
import PieChart from '../chartComponent/pie-chart.vue';
import RadioBtn from "@/components/common/radio-btn.vue";
export default {
  props: {
    data: Object,
    counter: Number,
  },
  components: {
    CardBorder,
    RadioBtn,
    PieChart
  },

  setup(props) {
    const radioBtnRef = ref(null);
    const DEFAULTCONFIG = [
      {
        label: '漏洞风险',
        value: 'scan'
      },
      {
        label: '隐私合规',
        value: 'compliance'
      }
    ];
    const selectOption = [
      { label: '全部', value: 'total', level: 'total' },
      { label: '高危', value: "high", level: 3 },
      { label: '中危', value: "middle", level: 2 },
      { label: '低危', value: "low", level: 1 },
    ];
    const typeActiveVal = ref(selectOption[0].value);
    const activeVal = ref(DEFAULTCONFIG[0].value);
    const chartData = ref([]);
    const radioChange = (val) => {
      activeVal.value = val;
      init();
    };
    const init = () => {
      if (props.data) {
        chartData.value = props.data[activeVal.value].map((item) => {
          return {
            name: item.name,
            value: activeVal.value === 'scan' ? item[typeActiveVal.value] : item.total,
          };
        });
      }
    };
    const handleSelectChange = (val) => {
      typeActiveVal.value = val;
      init();
    };
    const handleInterval = (type) => {
      radioBtnRef.value.handleInterval(type);
    };
    const handleLinkTo = () => {
      let url = activeVal.value === 'scan' ? '#/appSafe' : '#/appCompliance';
      window.location.href = url;
    };
    // 监听传值，刷新图表
    watch(props, () => {
      init();
    });

    init();
    return {
      activeVal,
      typeActiveVal,
      DEFAULTCONFIG,
      radioChange,
      props,
      chartData,
      selectOption,
      handleSelectChange,
      handleInterval,
      radioBtnRef,
      handleLinkTo
    };
  },
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>